// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';

import LogRocket from 'logrocket';

import './plugins/vuetify';
import './plugins/amplify';
import './plugins/chartist';

import './components';

import App from './App';
import router from './router';
import store from './store';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';

LogRocket.init('h75am5/cms-einkaufskreis', {
  console: {
    shouldAggregateConsoleErrors: true,
    isEnabled: {
      log: false,
      debug: false,
    },
  },
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
